import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from '@angular/core';
import { NavParams, ModalController, IonicModule } from '@ionic/angular';
import { Group, Zone, PositionedDeviceData, DeviceCardModalResult, Level, Project } from 'src/app/model';
import { AccessStoreService } from 'src/app/store/access-store.service';
import { ApiService } from 'src/app/providers/api/api.service';
import { HelperProvider } from 'src/app/providers/helper/helper';
import { DmStoreService } from 'src/app/store/dm-store.service';
import { sendSuccessTodnwaveio } from 'src/app/app.utils';
import { CommonModule } from '@angular/common';
import { UmStoreService } from 'src/app/store/um-store.service';

@Component({
  selector: 'app-device-card',
  templateUrl: './device-card.modal.html',
  styleUrls: ['./device-card.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [IonicModule, CommonModule],
})
export class ModalDeviceComponent implements OnInit {
  device: PositionedDeviceData;
  group: Group;
  zone: Zone;
  level: Level;
  project?: Project;
  selectedProject?: Project;

  public selectedProject$ = this.umStore.selectedProject$;

  loading = false;

  public access$ = this.acessState.writeaccess$;

  constructor(
    private acessState: AccessStoreService,
    private navParams: NavParams,
    private modalController: ModalController,
    private api: ApiService,
    private helper: HelperProvider,
    private dmStoreService: DmStoreService,
    private umStore: UmStoreService,
  ) { }

  async ngOnInit() {
    this.loading = true;
    this.device = await this.navParams.get('device');
    const zone = await this.api.zones.getZoneById(this.device.zone_id || 0, this.helper);
    const group = await this.api.groups.getGroupById(this.device.group_id || 0, this.helper);

    if (zone) {
      this.zone = zone;
      const project = await this.api.users.getProjectById(this.device.project_id || 0, this.helper);

      if (project) {
        this.project = project;
      }
    }

    if (group) {
      this.group = group;

      if (group.level_id) {
        const level = await this.api.levels.getLevelById(group.level_id);

        if (level) {
          this.level = level;
        }
      }
    }

    this.loading = false;
  }

  public async unbind() {
    if (!this.device.position_id) {
      return;
    }

    this.helper.showLoading();
    const unbind = await this.api.devices.undind(this.device.device_id, this.device.position_id);

    if (!unbind?.error) {
      this.dmStoreService.unbindDevice(this.device.device_id, this.device.position_id);
      const result: DeviceCardModalResult = {
        unbind: true,
      };
      this.helper.showToast('Device has been unbound successfully');
      sendSuccessTodnwaveio({ device: this.device.device_id });
      this.helper.hideLoading();
      this.modalController.dismiss(result);
    } else {
      this.helper.alert(unbind.error);
    }

    this.helper.hideLoading();
  }

  public async edit() {
    const result: DeviceCardModalResult = {
      edit: {
        zone: this.zone,
        group: this.group,
        level: this.level,
      },
    };
    this.modalController.dismiss(result);
  }

}
